/**
 * MODULE: _shared/frontend-shell/src/features/crm/utils/productAdoptionLabel.ts
 * PURPOSE: Human labels and pill styling for CRM product adoption statuses
 * PUBLIC_API: PRODUCT_ADOPTION_STATUSES, productAdoptionLabel, productAdoptionPillClass
 */

import type { CrmProductAdoptionStatus } from '@shared/lib/frontend/api/crmAccountProductsApi';

export const PRODUCT_ADOPTION_STATUSES: CrmProductAdoptionStatus[] = [
  'evaluation',
  'pilot',
  'active',
  'churned',
  'not_a_fit',
];

const LABELS: Record<CrmProductAdoptionStatus, string> = {
  evaluation: 'Evaluation',
  pilot: 'Pilot',
  active: 'Active',
  churned: 'Churned',
  not_a_fit: 'Not a fit',
};

const PILL: Record<CrmProductAdoptionStatus, string> = {
  evaluation: 'bg-amber-50 text-amber-800 dark:bg-amber-900/30 dark:text-amber-200',
  pilot: 'bg-sky-50 text-sky-800 dark:bg-sky-900/30 dark:text-sky-200',
  active: 'bg-emerald-50 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-200',
  churned: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
  not_a_fit: 'bg-rose-50 text-rose-700 dark:bg-rose-900/30 dark:text-rose-200',
};

export function productAdoptionLabel(status: CrmProductAdoptionStatus | string): string {
  return LABELS[status as CrmProductAdoptionStatus] ?? status;
}

export function productAdoptionPillClass(status: CrmProductAdoptionStatus | string): string {
  return PILL[status as CrmProductAdoptionStatus] ?? PILL.evaluation;
}

export function isActiveAdoption(status: CrmProductAdoptionStatus | string): boolean {
  return status === 'active' || status === 'pilot';
}
